export class ApiDefaults {
    public static readonly TakeAll = -1;
    public static readonly TakeDefault = 25;
}
